export { default as default } from './Noticia';
